import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { OAuthAccountOut, UserOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import {
  OAUTH_ACCOUNT_DEFAULT_TAB,
  OAUTH_ACCOUNT_SHOW_TABS,
} from '../constants';
import { OAuthAccountShowHeader } from './OAuthAccountShowHeader';
import { OAuthAccountGeneralTab } from './OAuthAccountGeneralTab';

export const OAuthAccountShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<OAuthAccountOut>({
    resource: 'iam.oauth_accounts',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: user } = useOne<UserOut>({
    resource: 'iam.users',
    id: record?.user_id ?? 0,
    queryOptions: { enabled: record?.user_id != null },
  });

  useRecordDocumentTitle(
    'iam.oauth_accounts',
    record ? record.account_email || `#${record.id}` : undefined
  );

  const [activeTab, onTabChange] = useShowTab(
    OAUTH_ACCOUNT_SHOW_TABS,
    OAUTH_ACCOUNT_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <OAuthAccountShowHeader
            record={record}
            user={user}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <OAuthAccountGeneralTab record={record} user={user} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
